module.exports = __webpack_public_path__ + "static/media/ph.b97d3243.webp";